<template>
  <div id="app">
      <transition name="fade" mode="out-in">
          <component :is="page"></component>
      </transition>
    <button id="button-to-scroll-top" class="returnTop flex-row" @click="scrollToTop"><img src="./img/slider_accueil/fleche.svg" alt=""></button>
  </div>
</template>

<script>

    window.onscroll = function (e) {
        let button = document.getElementById("button-to-scroll-top");
        let begin = 550;

        if (window.scrollY < begin+1) {
            button.classList.remove("active");
        }

        if (window.scrollY > begin) {
            button.classList.add("active");
        }

      };

    import { menuBus } from './main';

    import Accueil from "./components/accueil/Accueil";

    import Domaine from "./components/domaine/Domaine";
    import DomaineTransport from "./components/domaine/DomaineTransport";
    import DomaineCFCF from "./components/domaine/DomaineCFCF";
    import DomaineSecurite from "./components/domaine/DomaineSecurite";

    import Societe from "./components/societe/Societe";
    import SocieteAmbition from "./components/societe/SocieteAmbition";
    import SocietePhilosophie from "./components/societe/SocietePhilosophie";

    import Assistance from "./components/services/Assistance";
    import CentreService from "./components/services/CentreService";

    import Contact from "./components/contact/Contact";

    export default {
        name: 'app',
        data () {
          return {
              page: 'app-accueil',
          }
        },
        methods: {
            scrollToTop() {
                window.scrollTo(0,0);
            }
        },
        mounted() {
            menuBus.$on('changePage', (pageName, idName) => {
                this.page = 'app-' + pageName;
                if (idName == null)
                    window.scrollTo(0,0);
                else if (idName == "confiance") {
                    setTimeout(function () {
                        window.scrollTo(0, 20000);
                    }, 500);
                }
            })
        },
        components: {
            'app-accueil' : Accueil,
            'app-domaine' : Domaine,
            'app-domaine-transport' : DomaineTransport,
            'app-domaine-cfcf' : DomaineCFCF,
            'app-domaine-securite' : DomaineSecurite,
            'app-societe' : Societe,
            'app-societe-ambition' : SocieteAmbition,
            'app-societe-philosophie' : SocietePhilosophie,
            'app-assistance' : Assistance,
            'app-centre-service' : CentreService,
            'app-contact' : Contact,
        },
    }
</script>

<style>
  #app {
    font-family: 'Roboto', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
  }

  .returnTop {
    color: white;
    font-size: 25px;
    background-color: #b7e17e;
    border: none;
    box-shadow: 0px 10px 20px 2px #0000003b;
    display: none!important;
    cursor: pointer;

    position: fixed;
    z-index: 50;
    right: 20px;
    bottom: 20px;

    height: 80px;
    width: 50px;
  }
  .returnTop.active {
    display: flex!important;
  }
  .returnTop img {
    height: 40%;
    transform: rotate(90deg);
  }

  h1, h2 {
    font-weight: normal;
  }

  ul {
    list-style-type: none;
    padding: 0;
  }

  li {
    display: inline-block;
    margin: 0 10px;
  }

  a {
    color: #42b983;
  }

  .flex-row-space-evenly {
    display: flex;
    flex-direction: row;
    align-items: center;
    flex-wrap: nowrap;
    justify-content: space-evenly;
  }
  .flex-row-space-between {
    display: flex;
    flex-direction: row;
    align-items: center;
    flex-wrap: nowrap;
    justify-content: space-between;
  }
  .flex-row-space-between-wrap {
    display: flex;
    flex-direction: row;
    align-items: center;
    flex-wrap: wrap;
    justify-content: space-between;
  }
  .flex-column {
    display: flex;
    flex-direction: column;
    align-items: center;
    flex-wrap: nowrap;
    justify-content: center;
  }
  .flex-row-space-evenly-wrap {
    display: flex;
    flex-direction: row;
    align-items: center;
    flex-wrap: wrap;
    justify-content: space-evenly;
  }
  .flex-row-wrap {
    display: flex;
    flex-direction: row;
    align-items: center;
    flex-wrap: wrap;
    justify-content: center;
  }
  .flex-row {
    display: flex;
    flex-direction: row;
    align-items: center;
    flex-wrap: nowrap;
    justify-content: center;
  }

  * {
    font-family: "Roboto";
  }

  .fade-enter-active, .fade-leave-active {
    transition: opacity .3s;
  }
  .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue